import React, { useEffect, useState } from "react";
import { apiUrl } from "../../config";
import { preventClick } from "../../includes/function";

const initialState = {
    title: "",
    name: "",
    description: "",
    type: "main",
    bgColor1: "#ff0000",
    bgColor2: "#0000ff",
    titleColor: "#000000",
    nameColor: "#000000",
    descriptionColor: "#000000",
    imageUrl: "",
    linkUrl: "",
};

const SliderForm = ({ initialData, readOnly = false, onSave, loading, setLoading }) => {
    const [slider, setSlider] = useState(initialState);
    const [previewImage, setPreviewImage] = useState(null);
    const [backgroundGradient, setBackgroundGradient] = useState("");

    useEffect(() => {
        if (initialData) {
            setSlider({
                ...initialState,
                ...initialData,
            });

            if (initialData.imageUrl) {
                if (typeof initialData.imageUrl === "string") {
                    setPreviewImage(
                        initialData.imageUrl.startsWith("http")
                            ? initialData.imageUrl
                            : `${apiUrl}/${initialData.imageUrl}`
                    );
                } else if (initialData.imageUrl instanceof File) {
                    setPreviewImage(URL.createObjectURL(initialData.imageUrl));
                }
            } else {
                setPreviewImage(null);
            }
        } else {
            setSlider(initialState);
            setPreviewImage(null);
        }
    }, [initialData]);

    useEffect(() => {
        if (slider.bgColor1 && slider.bgColor2) {
            setBackgroundGradient(
                `linear-gradient(to right, ${slider.bgColor1}, ${slider.bgColor2})`
            );
        }
    }, [slider.bgColor1, slider.bgColor2]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSlider((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSlider((prev) => ({ ...prev, imageUrl: file }));
            setPreviewImage(URL.createObjectURL(file));
        }
    };

    const handleSubmit = () => {
        const dataToSave = { ...slider };

        if (initialData?.id) {
            dataToSave.id = initialData.id;
        }
        setLoading(true);
        onSave(dataToSave);
        setTimeout(() => {
            setLoading(false);
        }, 2000)
    };


    return (
        <div className="container">
            <div className="row">

                <div className="card p-4 shadow-sm rounded-4 mb-4">
                    <h5 className="mb-3 fw-bold">Slide Details</h5>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label fw-bold text-muted">Title</label>
                            <input
                                type="text"
                                className="form-control form-control-lg rounded-3"
                                name="title"
                                value={slider.title}
                                onChange={handleChange}
                                readOnly={readOnly}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-bold text-muted">Name</label>
                            <input
                                type="text"
                                className="form-control form-control-lg rounded-3"
                                name="name"
                                value={slider.name}
                                onChange={handleChange}
                                readOnly={readOnly}
                            />
                        </div>
                        <div className="col-md-12">
                            <label className="form-label fw-bold text-muted">Image</label>
                            {!readOnly && (
                                <input
                                    type="file"
                                    accept="image/*"
                                    className="form-control form-control-lg rounded-3"
                                    onChange={handleFileChange}
                                />
                            )}
                            {/* {previewImage && (
                                <div className="mt-2">
                                    <img
                                        src={previewImage}
                                        alt="Preview"
                                        style={{
                                            width: "120px",
                                            height: "100px",
                                            objectFit: "contain",
                                            borderRadius: "6px",
                                            border: "1px solid #ccc",
                                        }}
                                    />
                                </div>
                            )} */}
                        </div>
                        <div className="col-md-12">
                            <label className="form-label fw-bold text-muted">Link URL</label>
                            <input
                                type="text"
                                className="form-control form-control-lg rounded-3"
                                name="linkUrl"
                                value={slider.linkUrl || ""}   // ✅ ensures no null
                                onChange={handleChange}
                                readOnly={readOnly}
                                placeholder="https://example.com"
                            />
                        </div>

                        <div className="col-md-12">
                            <label className="form-label fw-bold text-muted">Description</label>
                            <textarea
                                className="form-control rounded-3"
                                rows="2"
                                name="description"
                                value={slider.description}
                                onChange={handleChange}
                                readOnly={readOnly}
                            />
                        </div>
                    </div>
                </div>

                <div className="card p-4 shadow-sm rounded-4 mb-4">
                    <h5 className="mb-3 fw-bold">Colors</h5>
                    <div className="row g-3">
                        <div className="col-md-2 col-6">
                            <label className="form-label fw-bold text-muted">Gradient 1</label>
                            <input
                                type="color"
                                className="form-control form-control-color"
                                name="bgColor1"
                                value={slider.bgColor1}
                                onChange={handleChange}
                                disabled={readOnly}
                            />
                        </div>
                        <div className="col-md-2 col-6">
                            <label className="form-label fw-bold text-muted">Gradient 2</label>
                            <input
                                type="color"
                                className="form-control form-control-color"
                                name="bgColor2"
                                value={slider.bgColor2}
                                onChange={handleChange}
                                disabled={readOnly}
                            />
                        </div>
                        <div className="col-md-2 col-6">
                            <label className="form-label fw-bold text-muted">Title</label>
                            <input
                                type="color"
                                className="form-control form-control-color"
                                name="titleColor"
                                value={slider.titleColor}
                                onChange={handleChange}
                                disabled={readOnly}
                            />
                        </div>
                        <div className="col-md-2 col-6">
                            <label className="form-label fw-bold text-muted">Name</label>
                            <input
                                type="color"
                                className="form-control form-control-color"
                                name="nameColor"
                                value={slider.nameColor}
                                onChange={handleChange}
                                disabled={readOnly}
                            />
                        </div>
                        <div className="col-md-2 col-6">
                            <label className="form-label fw-bold text-muted">Description</label>
                            <input
                                type="color"
                                className="form-control form-control-color"
                                name="descriptionColor"
                                value={slider.descriptionColor}
                                onChange={handleChange}
                                disabled={readOnly}
                            />
                        </div>
                    </div>
                </div>

                <div className="card shadow-sm rounded-4 p-3 mb-5">
                    <h5 className="text-start fw-bold mb-3">Preview</h5>
                    <div
                        style={{
                            width: "100%",
                            height: window.innerWidth < 786 ? "180px" : "350px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: backgroundGradient,
                            borderRadius: "12px",
                            padding: "20px",
                        }}
                    >
                        <div className="d-flex flex-wrap align-items-center justify-content-center w-100">
                            {previewImage && (
                                <img
                                    src={previewImage}
                                    alt="Slide"
                                    style={{
                                        maxWidth: "40%",
                                        height: "auto",
                                        borderRadius: "8px",
                                        marginRight: "20px",
                                        objectFit: "contain",
                                    }}
                                />
                            )}
                            <div>
                                <h2
                                    style={{
                                        color: slider.titleColor,
                                        fontSize: "clamp(18px, 3vw, 38px)",
                                    }}
                                >
                                    {slider.title}
                                </h2>
                                <p
                                    style={{
                                        color: slider.nameColor,
                                        fontSize: "clamp(14px, 2vw, 30px)",
                                        margin: 0,
                                    }}
                                >
                                    {slider.name}
                                </p>
                                <p
                                    style={{
                                        color: slider.descriptionColor,
                                        fontSize: "clamp(12px, 1.5vw, 20px)",
                                    }}
                                >
                                    {slider.description}
                                </p>
                            </div>
                        </div>
                    </div>

                    {!readOnly && (
                        <div className="text-end mt-4">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={(e) => {
                                    preventClick(e, handleSubmit);
                                }}
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Saving...
                                    </>
                                ) : (
                                    "Save"
                                )}
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary ms-2"
                                onClick={() => {
                                    setSlider(initialState);
                                    setPreviewImage(null);
                                }}
                            >
                                Clear
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SliderForm;
